module.exports = __webpack_public_path__ + "static/media/star.fd2700d2.svg";